import { Breadcrumb, Breadcrumbs as CCABreadcrumbs } from "@cca/components";
import { ElementType } from "react";
import { matchPath, NavLink } from "react-router-dom";
import useBreadcrumbs from "use-react-router-breadcrumbs";

export type RouteBreadcrumb = {
  breadcrumb: string | null;
  path: string;
  breadcrumbTestId?: string | null;
};

type BreadcrumbsProps<TProps> = {
  routes?: RouteBreadcrumb[];
  component?: ElementType<TProps>;
};

export const defaultRouteBreadcrumbs: RouteBreadcrumb[] = [
  { breadcrumb: "Home", path: "/" },
];

const Breadcrumbs = <TProps,>({
  routes = [],
}: BreadcrumbsProps<TProps> & TProps) => {
  const crumbs = useBreadcrumbs(routes.concat(defaultRouteBreadcrumbs));

  if (crumbs.length === 1) return null;

  return (
    <CCABreadcrumbs className="flex-wrap">
      {crumbs.map(({ breadcrumb, match, location }) => (
        <Breadcrumb
          active={!!matchPath(match.pathname, location.pathname)}
          component={NavLink}
          data-testid={
            routes.find((r) => r.breadcrumb == match.route?.breadcrumb)
              ?.breadcrumbTestId
          }
          key={match.pathname}
          to={match.pathname}
        >
          {breadcrumb}
        </Breadcrumb>
      ))}
    </CCABreadcrumbs>
  );
};

export default Breadcrumbs;
